import React from "react";
import PageHero from "../components/PageHero";
import { EditableText, EditableImage } from "../components/live/Editable";

const CERTS = [
  {
    img: "/assets/kiki/cert-main.jpg",
    title: "Kiki Centre For Technology",
    desc: "All students, depending on their performance in a course, receive a Certificate of Participation or Certificate of Completion, through Kiki Centre for Technology.",
  },
  {
    img: "/assets/kiki/cert-cgsc.jpg",
    title: "Capital Goods Skill Council",
    desc: "Anjali foundation (under the brand name of Kiki Centre for Technology) is a certified Affiliated Training Centre from Capital Goods Skill Council (CGSC).",
  },
  {
    img: "/assets/kiki/cert-ssc.jpg",
    title: "SSC, Ministry of Skill Development and Entrepreneurship, Government of India",
    desc: "Our institute is certified through the Capital Goods Sector Skills Council (CGSC) and Automotive Skill Development Council (ASDC). For those courses certified under CGSC & ASDC, the certificate is issued by Ministry of Skill Development and Entrepreneurship, Government of India.",
  },
  {
    img: "/assets/kiki/cert-tuv.jpg",
    title: "ISO 9000",
    desc: "Anjali foundation (under the brand name of Kiki Centre for Technology) is ISO 9000 compliant and we are accordingly certified for our systems through TUV Nord.",
  },
  {
    img: "/assets/kiki/cert-germany.jpg",
    title: "German Chamber of Skilled Crafts, Koblenz, Germany",
    desc: "Assessment and certification for the 3.5 years courses are through the German Chamber of Skilled Crafts, Koblenz, Germany.",
  },
];

export default function CertificationsPage() {
  return (
    <>
      <PageHero
        path="certifications.hero"
        kicker="Certifications"
        title="Certifications"
        subtitle="Recognized in India and globally — credentials that help you build a borderless career."
      />
      <section className="py-16">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          {CERTS.map((c, i) => (
            <div
              key={c.title}
              className={`grid md:grid-cols-5 gap-0 rounded-3xl overflow-hidden border border-slate-100 shadow-sm bg-white tilt-card animate-fade-up`}
              style={{ animationDelay: `${i * 0.07}s` }}
              data-testid={`certification-card-${i}`}
            >
              <div className={`md:col-span-2 bg-slate-50 flex items-center justify-center p-6 ${i % 2 === 1 ? "md:order-2" : ""}`}>
                <EditableImage
                  path={`certifications.${i}.image`}
                  src={c.img}
                  alt={c.title}
                  className="rounded-xl overflow-hidden"
                  imgClassName="max-h-56 w-auto object-contain"
                />
              </div>
              <div className="md:col-span-3 p-8 flex flex-col justify-center">
                <span className="inline-block w-fit px-3 py-1 rounded-full bg-yellow-400 text-[#0B2A6B] text-[11px] font-bold uppercase tracking-wider mb-4">
                  Certification {i + 1}
                </span>
                <EditableText path={`certifications.${i}.title`} as="h2" className="text-xl sm:text-2xl font-bold text-[#0B2A6B] mb-3 block">{c.title}</EditableText>
                <EditableText path={`certifications.${i}.desc`} as="p" multiline className="text-slate-600 leading-relaxed block">{c.desc}</EditableText>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
